import type {LocaleV3} from '@smart/locale-service';
import React from 'react';
import {useFeatureAppEnvHook} from './use-feature-app-env';

export function useLocale(): LocaleV3 {
  const {'locale-service': localeService} =
    useFeatureAppEnvHook().featureServices;
  const [locale, setLocale] = React.useState(localeService.getLocale());

  React.useEffect(() => localeService.subscribe(setLocale), [localeService]);

  return locale;
}
